import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.minimumGasPrices = this.minimumGasPrices.bind(this);
  }
  /* MinimumGasPrices */
  async minimumGasPrices(_params = {}) {
    const endpoint = `gaia/globalfee/v1beta1/minimum_gas_prices`;
    return await this.req.get(endpoint);
  }
}